exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".s-n-btn {\n  margin-right: 1.3em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/tags/edit-tages/edit-tages.component.scss
// module id = ../../../../../src/app/routes/restaurant/tags/edit-tages/edit-tages.component.scss
// module chunks = main